import { Children, useMemo } from 'react';
import MojitoCore from 'mojito/core';
import FlexPaneSeparator from 'presentation/components/flex-pane/separator/index.js';
import GridLayoutUtils from 'presentation/components/grid-layout/utils.js';

const { classUtils } = MojitoCore.Base;

const GridPane = props => {
    const {
        mojitoTools: { config },
        children,
        elementRef,
        gridTemplateColumns,
        repeatedColumnsNum,
        startColumn,
        endColumn,
        startRow,
        endRow,
    } = props;

    const { defaultColumnSize, nthSeparator } = config;

    const style = useMemo(() => {
        return GridLayoutUtils.enrichGridLayout(
            config.style,
            startColumn,
            endColumn,
            startRow,
            endRow
        );
    }, [config, startColumn, endColumn, startRow, endRow]);

    const configureGridTemplateColumns = () => {
        if (repeatedColumnsNum) {
            return `repeat(${repeatedColumnsNum}, ${defaultColumnSize})`;
        }
        return gridTemplateColumns || style.gridTemplateColumns;
    };

    const renderChildrenWithSeparator = () => {
        const items = [];
        Children.forEach(children, (child, idx) => {
            items.push(child);
            if (idx in nthSeparator) {
                items.push(
                    <FlexPaneSeparator
                        config={nthSeparator[idx]}
                        direction={'column'}
                        /* eslint-disable-next-line react/no-array-index-key */
                        key={`separator-${idx}`}
                    />
                );
            }
        });
        return items;
    };

    return (
        <div
            ref={elementRef}
            style={{
                ...style,
                position: 'relative', // Required in order to support absolute positioning over grid cells like in the race card
                gridTemplateColumns: configureGridTemplateColumns(),
            }}
            className={classUtils.classNames('ta-GridPane', props.class)}
        >
            {nthSeparator ? renderChildrenWithSeparator() : children}
        </div>
    );
};

export default GridPane;
